import React from "react";
import EntityProxy from "data/util/EntityProxy";
import { FluxMergeRecordSourceTreeGridLayout } from "../../mergebodylayout/FluxMergeRecordSourceTreeGridLayout";
import PropTypes from "prop-types";
import TreeItemStore from "data/TreeItemStore";
import MergeBodyLayout from "../../mergebodylayout/MergeBodyLayout";
import MergeStore from "data/MergeStore";
import { getAutoMergeRecordSummary } from "data/util/merge/mergeHelpers";
import MappingStore from "data/MappingStore";
import MergeActions from "data/MergeActions";
import useFluxStore from "@armus/use-flux-store";
import Dispatcher from "Dispatcher";
import { TableStore } from "data/TableStore";

const RecordMergeModuleView = (props) => {
    const {fluxContext, target, source, onCancel, onMerge, mergePlugin, sourceChildren} = props;
    const ctx = props.fluxContext;
    const typeLabelTitle = target.entityInfo.label;
    const typeLabel = typeLabelTitle.toLowerCase();
    if(!source) {
        return null;
    }

    const sourceLabel = <strong>{source.getLabel()}</strong>;
    const targetLabel = <strong>{target.getLabel()}</strong>;

    const body = {
        ...props,
        // for TreeStore
        ctx: ctx + ":" + mergePlugin,
        isKeyExpanded: TreeItemStore.getExpandedTest(ctx),
    };
    return (
        <div style={{marginLeft: -15, marginRight: -15}}>
            <MergeBodyLayout
                fluxContext={fluxContext}
                sourceLabel={sourceLabel}
                targetLabel={targetLabel}
                typeLabel={typeLabel}
                sourceChildren={sourceChildren}
                onMerge={onMerge}
                onCancel={onCancel}
            >
                <FluxMergeRecordSourceTreeGridLayout {...body} />
            </MergeBodyLayout>
        </div>
    );
};

RecordMergeModuleView.propTypes = {
    fluxContext: PropTypes.string.isRequired,
    mergePlugin: PropTypes.string.isRequired,
    target: PropTypes.instanceOf(EntityProxy).isRequired,
    source: PropTypes.instanceOf(EntityProxy),
    sourceChildren: PropTypes.array,
    onMerge: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const RecordMergeModule = (props) => {
    const { fluxContext } = props;
    const state = useFluxStore(() => {
        const mergeState = MergeStore.getState();
        const {source, target} = MergeStore.getProxyPair();
        return { // state
            ...props,
            target,
            source,
            sourceChildren: getAutoMergeRecordSummary(source),
            onMerge: () =>
                Dispatcher.contextDispatch(fluxContext, {
                    type: MergeActions.DO_MERGE,
                    source: mergeState.source,
                }),
        };
    }, [
        MappingStore,
        TableStore,
    ], [fluxContext]);
    return state.target !== null ? <RecordMergeModuleView {...state} /> : null;
};


RecordMergeModule.propTypes = {
    fluxContext: PropTypes.string.isRequired,
    mergePlugin: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default RecordMergeModule;





// WEBPACK FOOTER //
// ./app/lib/merge/views/record-merge/RecordMergeModule.js